<template>
  <div class="member-area-tab-placeholder-config-component">
    <div class="mb-3">
      <h5 class="text-semibold mb-1">
        Placeholders
      </h5>
      <small class="text-dark-40 fs-12">
        Defina imagens padrão que possam ser utilizadas caso algum conteúdo vá
        ao ar sem configuração de imagem. Assim, você garante que sua área de
        membros nunca passe a impressão de estar incompleta.
      </small>
    </div>

    <h5 class="text-semibold mb-1">
      Placeholder capa horizontal
    </h5>

    <div class="row mb-5">
      <div class="col-lg-4">
        <snow-input-file
          v-model="form.placeholder_cover"
          isImage
          backgroundColor="bg-1"
          id="horizontal-cover-image"
          title="Capa horizontal"
          dimensions="2160x740"
        />
      </div>
      <div class="col-lg-6 d-lg-flex d-none">
        <img src="@/assets/images/member-area/tab-placeholder-horizontal.svg" />
      </div>
    </div>

    <h5 class="text-semibold mb-1">
      Placeholder cartaz vertical
    </h5>

    <div class="row mb-5">
      <div class="col-lg-4">
        <snow-input-file
          v-model="form.placeholder_module"
          id="vertical-cover-image"
          isImage
          backgroundColor="bg-1"
          title="Cartaz vertical"
          dimensions="440x632"
        />
      </div>
      <div class="col-lg-6 d-lg-flex d-none">
        <img src="@/assets/images/member-area/tab-placeholder-vertical.svg" />
      </div>
    </div>

    <h5 class="text-semibold mb-1">
      Placeholder cartaz horizontal
    </h5>

    <div class="row">
      <div class="col-lg-4">
        <snow-input-file
          v-model="form.placeholder_lesson"
          id="horizontal-poster-image"
          isImage
          backgroundColor="bg-1"
          title="Cartaz das aulas"
          dimensions="686x414"
        />
      </div>
      <div class="col-lg-6 d-lg-flex d-none">
        <img
          src="@/assets/images/member-area/tab-placeholder-poster-horizontal.svg"
        />
      </div>
    </div>

    <!-- <h5 class="text-semibold mb-1">
      Placeholder capa versão mobile
    </h5>

    <snow-input-file
      v-model="form.placeholder_cover_mobile"
      id="horizontal-poster-image"
      isImage
      backgroundColor="bg-1"
      title="Cartaz horizontal"
      dimensions="375x495"
    /> -->
  </div>
</template>
<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
<style lang="scss" scoped>
.member-area-tab-placeholder-config-component {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
